module.exports = __webpack_public_path__ + "static/media/education-object-4-0-2.994d9040.svg";